import React from 'react';
import clsx from 'clsx';

import './index.scss';
import check from 'assets/check.svg';

const CheckIcon = ({ color })=>{

  return (
    <div className={clsx('CheckIcon', 
      { gray: color === '0' },
      { lightGray: color === '1' },
      { blue: color === '2' },
    )}
    >
      <img className="check" src={check} alt=""  />
    </div>
  );
};

export default CheckIcon;